import { COOKIES_TIMES } from ".constants/cookies";

export const COOKIE_OPTIONS = {
  maxAge: COOKIES_TIMES.YEAR_1,
  sameSite: "lax" as const,
};
